import * as React from "react";
function SvgChevronLeft(props, svgRef) {
    return (
        <svg
            width="1em"
            height="1em"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            ref={svgRef}
            {...props}
        >
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M7.293 11.293l8-8 1.414 1.414L9.414 12l7.293 7.293-1.414 1.414-8-8a1 1 0 010-1.414z"
                fill="currentcolor"
            />
        </svg>
    );
}
const ForwardRef = React.forwardRef(SvgChevronLeft);
export default ForwardRef;
